import * as React from 'react';
import { styles } from './styles';
import { DesignBucketShell, DesignBucketShellProps } from '../components/DesignBucketShell';
import { DesignShowcaseSectionConfig } from '../../..';
import { capitalize } from 'utils/strings';
import { InlineDialogProps } from '../../InlineDialog';
import { InviteCheckbox } from './components/InviteCheckbox';

interface Props extends DesignShowcaseSectionConfig<string> {
  onOptionSelect: React.MouseEventHandler<HTMLElement>;
  onCloseRequest: InlineDialogProps<null>['onCloseRequest'];
  isMobile?: boolean;
}

const invites = [
  { type: 'ecard', title: 'Ecards', displayString: 'Matching ecard invites' },
  { type: 'print', title: 'Prints', displayString: 'Matching print invites' }
];

export class InviteBucket extends React.Component<Props & DesignBucketShellProps> {
  render() {
    const valueString = this.props.values.map(val => capitalize(val)).join(', ');

    return (
      <DesignBucketShell
        section="invites"
        isMobile={this.props.isMobile}
        label="Invites"
        open={this.props.open}
        onClose={this.props.onCloseRequest}
        subtitle={valueString}
        onTriggerClick={this.props.onTriggerClick}
        onResetClick={this.props.onResetClick}
      >
        <DesignBucketShell.Content className={styles.container}>
          {invites.map(v => {
            return (
              <InviteCheckbox
                value={v.type}
                key={v.type}
                checked={!!this.props.values.find(el => el === v.type)}
                data-section="invites"
                label={v.displayString}
                onClick={this.props.onOptionSelect}
                title={capitalize(v.title)}
              />
            );
          })}
        </DesignBucketShell.Content>
      </DesignBucketShell>
    );
  }
}
